module.exports = __webpack_public_path__ + "static/media/instagram.d49a6fa4.svg";